export const defaultLanguage = "en"

const supportedLanguages = {
    "de": "Deutsch",
    "en": "English",
    "fr": "Français",
    "hu": "Magyar",
    "nl": "Nederlands",
    "pl": "Polski",
    "es": "Español",
    "ro": "Română",
    "it": "Italian",
    "sk": "Slovenčina",
    "cs": "Čeština",
    "bg": "Български"
}


export function getSupportedLanguages() {
    return { ...supportedLanguages }
}
